import { Trans } from '@lingui/react/macro';

import { useCanaryFinalRecommendations } from '@/api/aiVisibility';
import { LinkButton } from '@/components/buttons';
import { Empty } from '@/components/Empty';
import WidgetError from '@/components/errors/WidgetError';
import { Skeleton } from '@/components/Skeleton';
import { Text, Title } from '@/components/typography';
import { ROUTES } from '@/router';

const AIVisibilityInsightsSummary = () => {
  const { summary, isLoading, error } = useCanaryFinalRecommendations();

  return (
    <section className="flex flex-col rounded-2xl bg-linear-to-r from-gray-100 to-green-200 px-5 py-4">
      <Title level={2} variant="footnote">
        <Trans>INSIGHTS SUMMARY</Trans>
      </Title>
      {isLoading && (
        <div className="mt-2 space-y-1" aria-busy="true">
          <Skeleton className="h-5" />
          <Skeleton className="h-5" />
          <Skeleton className="h-5" />
        </div>
      )}
      {!isLoading && !!error && (
        <WidgetError message={<Trans>Unable to load insights summary.</Trans>} />
      )}
      {!isLoading && !error && !summary?.length && (
        <Empty>
          <Trans>No insights summary available.</Trans>
        </Empty>
      )}
      {!isLoading && !error && !!summary?.length && (
        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-gray-700">
          {summary.map((item, index) => (
            <li key={index}>
              <Text variant="footnote" weight="regular">
                {item}
              </Text>
            </li>
          ))}
        </ul>
      )}
      <LinkButton
        to={ROUTES.aiVisibilityRecommendations.path}
        size="small"
        className="mt-auto ml-auto px-4 font-medium"
      >
        <Trans>Close gaps</Trans>
      </LinkButton>
    </section>
  );
};

export default AIVisibilityInsightsSummary;
